import Vue from 'vue'
import Vuex from 'vuex'

import { Store as login } from "@/modules/login";
import { Store as home } from "@/modules/home";
import { Store as caviteEdit } from "@/modules/cavite-edit";
import { Store as admin } from "@/modules/admin";

//from components
import dynPanel from "@/components/dyn-panel/store";
import notifications from "@/components/notifications/store";
import { getLexiques } from './lib/services';
import BeanCoord from './lib/models/bean-coord';
import AbstractGenLex from './lib/models/abstract-gen-lex';
import { LoginState } from './modules/login/store';
import { HomeState } from './modules/home/store';
import { STATUT_VALIDE, STATUT_NON_VISE, STATUT_REFUSE } from './lib/constants/validation';
import { notEmpty } from './lib/helpers';

Vue.use(Vuex)

type CTor = new () => unknown;

export type RootState = {
  isHelpEnabled: boolean;
  lexiques: {name: string; lexiques: AbstractGenLex}[];
  login: LoginState;
  home: HomeState;
};

export default new Vuex.Store({
  modules: {
    caviteEdit,
    dynPanel,
    login,
    home,
    notifications,
    admin
  },
  state: <RootState>{
    isHelpEnabled: false,
    lexiques: []
  },
  getters: {
    getLexique: (state: RootState) => (name: string | CTor) => {
      let n;
      if (typeof name === "string") {
        n = name;
      } else {
        n = (name as CTor).name;
      }
      switch (n) {
        case "StatutValidation": return [
          {id: STATUT_VALIDE, label: "Validé"},
          {id: STATUT_NON_VISE, label: "Non visé"},
          {id: STATUT_REFUSE, label: "Refusé"}
        ];
        case "OuiNon": return [
          {value: true, label: "Oui"},
          {value: false, label: "Non"}
        ];
        default:
          const bean = state.lexiques.find(l => l.name === n);
          return bean && bean.lexiques;
      }
    },
    userDepts: (state: RootState, getters) => {
      if ((<any>state).login.loggedUser && state.lexiques.length) {
        const lexDepts = getters.getLexique("ComDept");
        const userDeptsString = (<any>state).login.loggedUser.depts;
        if (userDeptsString === "ALL") {
          return lexDepts;
        } else {
          return (userDeptsString || "").split(/,/g)
            .map(s => lexDepts.find(ld => ld.numDept === s.trim()));
        }
      }
      return [];
    },
    getPositionableBeanCoord: (_, getters) => (obj: {xouvrage: number, youvrage: number, lambertOuvrage: number}): BeanCoord => {
      if (obj.xouvrage != null && obj.youvrage != null && obj.lambertOuvrage) {
        const syst = getters.getLexValue("ComSystProjectFrance", obj.lambertOuvrage, l => l.codeSystProjection);
        return new BeanCoord().inject({x: obj.xouvrage, y: obj.youvrage, epsg: syst.epsg.toLowerCase()})
      }
      return null;
    },
    getLexValue: (_, getters) => (name: string, key: any, transform = v => v.id, eqFn = (a, b) => a === b) => {
      return getters.getLexique(name).find(l => eqFn(transform(l), key));
    }
  },
  mutations: {
    toggleHelp(state: RootState) {
      state.isHelpEnabled = !state.isHelpEnabled;
    },
    setLexiques(state, {lexs}) {
      state.lexiques = lexs;
    }
  },
  actions: {
    async loadLexiques({commit}) {
      const lexs = await getLexiques();
      commit("setLexiques", {lexs});
    }
  }
})
